import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import BenefitsSection from './components/BenefitsSection';
import TintShadesSection from './components/TintShadesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../utils/seo';

export default function HomePage() {
  useSEO({
    title: 'U.B.K Window Tint Services - Professional Window Tinting Baltimore MD',
    description: 'Professional window tinting services in Baltimore, Maryland. Ceramic & standard tint, mobile service, commercial tinting, vehicle decals, and headlight/taillight tinting. Call (443) 800-0348 for a free quote.',
    keywords: 'window tinting Baltimore, mobile tinting Maryland, ceramic tint, vehicle decals, headlight tinting, commercial tinting',
    canonical: '/',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateLocalBusinessSchema(),
        generateWebPageSchema(
          'U.B.K Window Tint Services - Professional Window Tinting Baltimore MD',
          'Professional window tinting services in Baltimore, Maryland. Ceramic & standard tint, mobile service, commercial tinting, vehicle decals, and headlight/taillight tinting.',
          '/'
        ),
      ],
    },
  });

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">U.B.K Window Tint Services - Professional Window Tinting Baltimore MD</h1>
      </header>
      <main>
        <HeroSection />
        <ServicesSection />
        <BenefitsSection />
        <TintShadesSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
